export default __webpack_public_path__ + "static/media/prev-MDS-4.df501159.png";